<template>
 <div class="d-inline-flex">
    <v-col class="pa-0">
      <v-row>
        <v-col class="mb-0 pb-1">
          <h4 v-if="UseDayPricingForSubscriptions" class="text-start">
            <span v-if="showRetailPrice" class="discount-price text-subtitle-2 text--secondary">
              {{ formatter.format(totalRetailPrice) }}
            </span>
            {{ formatter.format(totalPrice) }}
            <span v-if="isProfUser" class="text-caption text--secondary">
              {{ $translate('EXCL_VAT') }}
            </span>
          </h4>
          <h4 v-if="!UseDayPricingForSubscriptions" class="text-end">
            <span v-if="showRetailPrice" class="discount-price text-subtitle-2 text--secondary">
              {{ formatter.format(totalRetailPrice) }}
            </span>
            {{ formatter.format(totalPrice) }}
            <span v-if="isProfUser" class="text-caption text--secondary">
              {{ $translate('EXCL_VAT') }}
            </span>
          </h4>
          <h5 v-if="product.DepositValue > 0" class="">
              {{$translate('DEPOSIT_VALUE')}}: {{ formatter.format(product.DepositValue) }}
          </h5>
        </v-col>
      </v-row>
      <v-row v-if="UseDayPricingForSubscriptions" class="mt-0 pt-0">

        <v-col style="width: 265px; font-size: smaller;">
          <span>
            <v-icon size="22" color="info"> mdi-information-outline</v-icon>
            {{$translate('USE_DAY_PRICING')}}
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <ProductQuantityButtons
            :quantity="quantity"
            :unit="unit"
            :isWeighted="isWeighted"
            :increaseBtnDisabled="increaseBtnDisabled"
            :decreaseBtnDisabled="decreaseBtnDisabled"
            @decrease="onDecreaseBtnClick"
            @increase="onIncreaseBtnClick"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-row v-show="showDeleteBtn" class="ma-0 ml-3" align="end">
      <v-btn icon color="red accent-3" small @click="onRemoveBtnClick">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { isWeightedProduct } from '@/objects/Product';
import ProductQuantityButtons from '@/components/event/productDetails/ProductQuantityButtons';

export default {
  name: 'ShoppingListProductActions',
  components: {
    ProductQuantityButtons,
  },
  props: {
    product: Object,
    totalPrice: Number,
    quantity: Number,
    unit: String,
    isWeighted: Boolean,
    showDeleteBtn: {
      type: Boolean,
      default: true,
    },
    increaseBtnDisabled: Boolean,
    decreaseBtnDisabled: Boolean,
  },
  emits: ['decrease', 'increase', 'delete'],
  computed: {
    isProfUser() {
      return this.$store.getters.isProfUser;
    },
    showRetailPrice() {
      if (this.product == null) {
        return false;
      }

      let retailPriceValue = 0.0;
      let priceValue = 0.0;

      if (
        this.product.ItemRetailPrice != null &&
        this.product.ItemPrice != null
      ) {
        // Order already made
        retailPriceValue = Number(this.product.ItemRetailPrice);
        priceValue = Number(this.product.ItemPrice);
      } else if (
        this.product.RetailPrice != null &&
        this.product.Price != null
      ) {
        // Order not made yet, like 'Wishlist'
        retailPriceValue = Number(this.product.RetailPrice);
        priceValue = Number(this.product.Price);
      }

      let priceDiff = 0.0;
      if (!Number.isNaN(retailPriceValue) && !Number.isNaN(priceValue)) {
        priceDiff = retailPriceValue - priceValue;
      }

      return retailPriceValue > 0 && priceDiff > 0.01;
    },
    totalRetailPrice() {
      if (this.product.ItemRetailPrice != null) {
        let amount = this.product.Quantity;
        if (isWeightedProduct(this.product)) {
          amount = this.product.Quantity / this.product.StepSize;
        }

        if (this.isProfUser) {
          return (
            amount *
            (this.product.ItemRetailPrice - this.product.ItemRetailVatPrice)
          );
        }

        return amount * this.product.ItemRetailPrice;
      }

      if (this.isProfUser) {
        return this.product.RetailPriceExVat;
      }
      return this.product.RetailPrice;
    },
  },
  mounted(){
    this.partnerGroupDetails()
  },
  data() {
    return {
      UseDayPricingForSubscriptions: false,
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    partnerGroupDetails() {
      this.UseDayPricingForSubscriptions = this.$store.getters['Account/partnerGroupDetails'].UseDayPricingForSubscriptions;

      return this.UseDayPricingForSubscriptions;
    },
    onDecreaseBtnClick() {
      this.$emit('decrease');
    },
    onIncreaseBtnClick() {
      this.$emit('increase');
    },
    onRemoveBtnClick() {
      this.$emit('delete');
    },
  },
};
</script>
